<template>
	<section class="scrolly-game-intro stack-vertical" data-align="center">
		<p class="uppercase">{{$t('generic_gioco').toUpperCase()}}</p>
		<h2 class="game-name capitalize-first">{{name}}</h2>
		<base-button type="variant4" :text="utils.capitalizeFirst($t('generic_gioca'))" @clicked="startGame"/>
	</section>
</template>

<script type="text/javascript">

import utils from '@js/utils.js';

export default {
	name: 'InterfaceGameIntro',
	props: {
		name: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			utils
		}
	},
	methods: {
		startGame() {
			this.$emit('start-game')
		}
	}
}

</script>

<style lang="scss">
	@import "@css/variables.scss";

	.scrolly-game-intro {
		display: flex;
		flex-direction: column;
		justify-content: center;
		gap: 2.5rem;
	}

	.game-name {
		font-size: 3.75rem;
		text-align: center;
	}

	@media (max-width: $breakpoint-sm) {
		.game-name {
			font-size: 2.5rem;
		}
	}

</style>
